import { t } from "app/utils";

const makeSharedString = (connection, organizationName) => {
  const shared = [];

  ["Connection", "Department", "Interest", "Location", "ClassYear", "Club", "Program", "Degree"].forEach(type => {
    const value = connection[`common${type}`];
    if (value) {
      if ((type === "ClassYear") && (organizationName === "Dartmouth Guarini")) {
        shared.push(`${value} ${value === 1 ? "year in program" : "years in program"}`);
      } else if ((type === "Department") && (organizationName === "Deloitte")) {
        shared.push(`${value} ${value === 1 ? "business" : "businesses"}`);
      } else if ((type === "Department") && (organizationName === "RTX")) {
        shared.push(`${value} ${value === 1 ? "job function" : "job functions"}`);
      } else if ((type === "Department") && (organizationName === "Microsoft")) {
        shared.push(`${value} ${value === 1 ? "profession" : "professions"}`);
      } else if (type === "Department") {
        shared.push(`${value} ${type.toLowerCase()}${value === 1 ? "" : "s"}`);
      } else {
        shared.push(`${value} ${type === "ClassYear" ? "class year" : type.toLowerCase()}${value === 1 ? "" : "s"}`);
      }
    }
  });

  return shared.length > 0 ? t(`Shares ${shared.join(", ")}`) : null;
};

export default makeSharedString;
